// src/components/settings/SettingsContent.tsx
import React, { Suspense, lazy } from "react";

const PipelineSettingsPage = lazy(() => import("./sections/PipelineSettingsPage"));
const UsersSettingsPage = lazy(() => import("./sections/components/UsersPage/UsersPage"));
const ProductCategoriesPage = lazy(() => import("./sections/ProductCategoriesSettings"));
const ProductsPage = lazy(() => import("./sections/ProductSettings"));
const ClientsSettingsPage = lazy(() => import("../settings/sections/ClientSettings"));
const SiteSettingsPage = lazy(() => import("./sections/SiteSettingsPage"));
const HalykMarketSettings = lazy(() => import("./sections/HalykMarketSettings"));
const KaspiSettings = lazy(() => import("./sections/KaspiSettings"));
const NotificationsSettingsPage = lazy(() => import("./sections/NotificationsSettingsPage"));
const UkassaSettingsPage = lazy(() => import("./sections/UkassaSettings"));
const MonttechSettingsPage = lazy(() => import("./sections/MonttechSettings"));
const PaymentTypesSettingsPage = lazy(() => import("./sections/PaymentTypesSettings"));
const MailSettingsPage = lazy(() => import("./sections/MailSettings"));
const OrganizationSettingsPage = lazy(() => import("./sections/OrganizationSettings"));
const AlStyleSettingsPage = lazy(() => import("./sections/AlStyleSettings"));
const ContractsSettingsPage = lazy(() => import('./sections/ContractsSettings'));

interface Props {
  section?: string;
  role: string; // ← добавили
}

export default function SettingsContent({ section = "pipeline" }: Props) {
  function renderSection() {
    switch (section) {
      case "organization":
        return <OrganizationSettingsPage />;
      case "pipeline":
        return <PipelineSettingsPage />;
      case "users":
        return <UsersSettingsPage />;
      case "productCategories":
        return <ProductCategoriesPage />;
      case "products":
        return <ProductsPage />;
      case "clients":
        return <ClientsSettingsPage />;
      case "siteSettings":
        return <SiteSettingsPage />;
      case "halykMarket":
        return <HalykMarketSettings />;
      case "kaspi":
        return <KaspiSettings />;
      case "notifications":
        return <NotificationsSettingsPage />;
      case "ukassa":
        return <UkassaSettingsPage />;
      case "monttech":
        return <MonttechSettingsPage />;
      case "paymentTypes":
        return <PaymentTypesSettingsPage />;
      case "mail":
        return <MailSettingsPage />;
      case "contracts":
        return <ContractsSettingsPage />;
      case "alStyle":
        return <AlStyleSettingsPage />;
      default:
        return (
          <div className="settings-content-fallback">
            Раздел не найден: {section}
          </div>
        );
    }
  }

  return (
    <div className="settings-content">
      <Suspense
        fallback={
          <div className="settings-loading">
            Загрузка…
          </div>
        }
      >
        {renderSection()}
      </Suspense>
    </div>
  );
}